<template>
	<div class="flex flex_col procudtionm-page">
		<!-- 上面的下拉选择 -->
		<div class="flex flex_a_c page-selects">
			<img class="icon-small" src="@/assets/image/production/icon_small.png" alt="" />
			<el-form :model="orgForm" class="top-forms warnform-inline" :inline="true" ref="selectForm">
				<el-form-item label="选择生产区域" v-if="isShowAllSelect">
					<el-select
						v-model="allOrgId"
						:placeholder="orgAllSelect.length ? '请选择' : '暂无设备'"
						@change="changeAllOrg"
					>
						<el-option
							v-for="(item, index) in orgAllSelect"
							:key="index"
							:value="item.orgId"
							:label="item.orgName"
						></el-option>
					</el-select>
				</el-form-item>
				<el-form-item :label="isShowAllSelect ? '' : '选择生产区域'" style="margin-bottom: 0">
					<el-select
						v-model="orgForm.orgId"
						:placeholder="orgSelect.length ? '请选择' : '暂无设备'"
						@change="changeOrg"
					>
						<el-option
							v-for="(item, index) in orgSelect"
							:key="index"
							:value="item.orgId"
							:label="item.orgName"
						></el-option>
					</el-select>
				</el-form-item>
			</el-form>
		</div>
		<!-- 页面内容 -->
		<div class="flex flex_ju_sb content-wraps" v-loading="loading">
			<!-- 左边 -->
			<div class="left-wrap">
				<!-- 上面 -->
				<div class="lt-wrap">
					<title-model titles="视频监控" :isBorder="false">
						<el-form ref="ltForm" :model="videoForm" class="warnform-inline" style="padding: 0">
							<el-form-item>
								<el-select
									v-model="videoForm.id"
									@change="handleVideoChange"
									:placeholder="videoSelect.length ? '请选择' : '暂无设备'"
								>
									<el-option
										v-for="(item, index) in videoSelect"
										:key="index"
										:label="item.vname"
										:value="item.id"
									></el-option>
								</el-select>
							</el-form-item>
						</el-form>
					</title-model>
					<!-- 视频 -->
					<div class="lt-videos">
						<!-- <hw-cell-player
							v-show="isShowVideo"
							:code="videoForm.vcode"
							ref="hlsVideoPlayer"
							style="width: 100%; height: 100%"
							:isShowclose="false"
						></hw-cell-player> -->
						<production-videos
							v-show="isShowVideo && !isVideoEmpty"
							ref="hlsVideoPlayer"
							style="width: 100%; height: 100%"
						></production-videos>
						<!-- <videos v-show="isShowVideo" ref="hlsVideoPlayer" style="width: 100%; height: 100%"></videos> -->
						<div class="flex flex_col flex_a_c flex_ju_c play-error" v-show="isShowVideo && isVideoEmpty">
							<img class="img_noplay" src="@/assets/image/videos/noplay.png" alt="" />
							<div class="font_16 c_white">暂无视频数据</div>
						</div>
						<div class="flex flex_col flex_a_c flex_ju_c play-error" v-show="!isShowVideo">
							<img class="img_noplay" src="@/assets/image/videos/noplay.png" alt="" />
							<div class="font_16 c_white">暂无监控设备</div>
						</div>
					</div>
				</div>
				<!-- 下面 -->
				<div class="tb-wrap">
					<title-model titles="设备操作">
						<span slot="other">
							<el-popover
								placement="right-start"
								width="280"
								trigger="hover"
								content="开关设备
点击开关后，当网络出现延时等情况，会出现XX详情中的提示，请等待状态值的变化，来确定最终的开关动作结果；
行程设备
点击上升或下降后，请注意百分比的变化情况，同时注意设备的实际情况，必要时，请立即点击停止操作；
如果发现页面显示已经100%，实际还没到，请下载app，在现场结合手机端的校准操作来完成设备的校准，已达到后续操作的页面显示位置和设备位置一致。

"
							>
								<img slot="reference" class="tips-img" src="@/assets/image/monitor/shuoming.png" alt="" />
							</el-popover>
						</span>
						<!-- TODO 不要删除，目前没有判断设备异常的字段，不做展示 -->
						<!-- <div class="flex flex_a_c flex_ju_c">
							<img class="icon_warn" src="@/assets/image/home/icon_warn.png" alt="" /><span class="font_14 c_six"
								>设备异常!</span
							>
						</div> -->
						<div class="btn-switchs">
							<div class="btn-switch-btn" :class="{ 'btn-switch-active': tabIndex == 0 }" @click="changeTab(0)">
								开关设备
							</div>
							<div class="btn-switch-btn" :class="{ 'btn-switch-active': tabIndex == 1 }" @click="changeTab(1)">
								行程设备
							</div>
							<div class="bgs" :style="bgsStyle"></div>
						</div>
					</title-model>
					<!-- 设备 -->
					<div class="lb-mains">
						<!-- 开关设备 -->
						<div v-if="tabIndex == 0">
							<div v-if="equipListSd.length">
								<div
									v-for="(item, index) in equipListSd"
									:key="index"
									class="switch-wrap"
									:class="{
										'switch-wrap-off': item.deviceStatus == 'OFF',
									}"
								>
									<!-- <div v-if="codeIsWarn" class="codewarn"></div> -->
									<div class="flex flex_a_c flex_ju_sb switch-div" @click="setEquip(item)">
										<div class="flex flex_a_c">
											<img class="switch-img" src="@/assets/image/production/switch_img.png" alt="" />
											<div class="font_16">
												<div class="switch-name">
													{{ item.deviceName }}
												</div>
												<div class="switch-status">已{{ item.deviceStatusDesc }}</div>
											</div>
										</div>
										<img
											class="cursor set_icon"
											:src="
												item.deviceStatus == 'OFF'
													? require('@/assets/image/production/set_closeh.png')
													: require('@/assets/image/production/set_openh.png')
											"
											alt=""
										/>
									</div>
								</div>
							</div>
							<div class="table-empty bottom-empty table-empty-big flex flex_col flex_a_c flex_ju_c right-empty" v-else>
								<img class="table-noimg" src="@/assets/image/sf/empty.png" alt="" />
								<div class="table-emptyword">该网点暂无操作设备!</div>
							</div>
						</div>
						<!-- 行程设备 -->
						<div v-if="tabIndex == 1">
							<div v-if="equipListSsd.length">
								<div class="equip-div" v-for="(item, index) in equipListSsd" :key="index">
									<!-- <div v-if="codeIsWarn" class="codewarn"></div> -->
									<!-- 设备和状态 -->
									<div class="flex flex_a_c flex_ju_c">
										<img
											class="equip-img"
											v-if="item.deviceName.indexOf('卷被') > -1"
											src="@/assets/image/production/icon_jb.png"
											alt=""
										/>
										<img
											class="equip-img"
											v-else-if="item.deviceName.indexOf('放风') > -1"
											src="@/assets/image/production/icon_ff.png"
											alt=""
										/>
										<div>
											<div class="equip-name">
												{{ item.deviceName }}
											</div>
											<div class="equip-status">
												<!-- {{ item.deviceStatus == 'STOP' ? '停止响应中' : '已' + item.deviceStatusDesc }} -->
												{{ equipWord(item) }}
											</div>
										</div>
									</div>
									<!-- 进度条 -->
									<div class="flex flex_col flex_ju_c font_14 c_45 div-progress">
										<span class="progress-num">{{ item.ssdDeviceStatus }}%</span>
										<div class="flex flex_ju_c flex_a_c">
											<span>0%</span>
											<div class="progress-bg">
												<div
													class="progress-had"
													:style="{
														width: item.ssdDeviceStatus + '%',
													}"
												></div>
											</div>
											<span>100%</span>
										</div>
									</div>
									<!-- 操作 -->
									<div class="flex flex_ju_sb flex_a_c equip-sets">
										<div
											class="flex flex_col flex_a_c flex_ju_c equip-setdiv"
											@click="setEquiptwo(item, 'DOWN', index)"
										>
											<img class="seticon seticon-smallicon" :src="equipImg(item, 'DOWN')" alt="" />
											<span class="font_14">下降</span>
										</div>
										<div
											class="flex flex_col flex_a_c flex_ju_c equip-setdiv"
											@click="setEquiptwo(item, 'STOP', index)"
										>
											<img class="seticon" :src="equipImg(item, 'STOP')" alt="" />
											<span class="font_14">停止</span>
										</div>
										<div class="flex flex_col flex_a_c flex_ju_c equip-setdiv" @click="setEquiptwo(item, 'UP', index)">
											<img class="seticon seticon-smallicon" :src="equipImg(item, 'UP')" alt="" />
											<span class="font_14">上升</span>
										</div>
									</div>
								</div>
							</div>
							<div class="table-empty bottom-empty table-empty-big flex flex_col flex_a_c flex_ju_c right-empty" v-else>
								<img class="table-noimg" src="@/assets/image/sf/empty.png" alt="" />
								<div class="table-emptyword">该网点暂无操作设备!</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 右边监测 -->
			<div class="flex flex_col right-wrap">
				<title-model titles="环境监测" widths="11.09rem" paddings="0 .07rem 0 .28rem">
					<el-form ref="rightForm" :model="codeForm" class="warnform-inline" style="padding: 0">
						<el-form-item>
							<el-select
								v-model="codeForm.deviceId"
								@change="codeChangeHandel"
								:placeholder="codeSelect.length ? '请选择' : '暂无设备'"
							>
								<el-option
									v-for="(item, index) in codeSelect"
									:key="index"
									:label="item.deviceName"
									:value="item.id"
								></el-option>
							</el-select>
						</el-form-item>
					</el-form>
				</title-model>
				<!-- 上面具体数据 -->
				<div class="right-top" v-if="codeSelect.length">
					<div class="rt-relative">
						<div class="relative-div" :class="{ 'relative-div-noleft': codeInfoLisst.length == 1 }">
							<div v-if="codeIsWarn" class="flex flex_a_c flex_ju_c top-tipdiv">
								<img class="icon_warn" src="@/assets/image/home/icon_warn.png" alt="" /><span class="font_14 c_six"
									>设备异常!</span
								>
							</div>
							<div v-else class="font_14 c_six top-tipdiv">采集时间：{{ codeInfos.dateTime || '--' }}</div>
							<img class="img_bg" src="@/assets/image/production/img_bg.png" alt="" />
						</div>
					</div>
					<div class="flex flex_ju_sb rt-absolute">
						<!-- 左边的 -->
						<production-left
							:data="codeLeftList"
							v-if="codeInfoLisst.length > 1 || codeInfoLisst.length == 0"
						></production-left>
						<div class="rights"></div>
						<production-right
							:data="codeRightList"
							:ent-length="codeInfoLisst.length"
							:class="{ 'right-noleft': codeInfoLisst.length == 1 }"
						></production-right>
						<!-- 右边的 -->
					</div>
					<div v-if="codeTotalPage > 1" class="flex flex_a_c code-pages">
						<span
							class="cursor el-icon-caret-left code-icon"
							:class="{ 'code-icon-hui': codePage == 1 }"
							@click="codePageChange('-')"
						></span>
						<div class="c_six">
							<span style="color: #42b5b2">{{ codePage }}</span
							>/{{ codeTotalPage }}
						</div>
						<span
							class="cursor el-icon-caret-right code-icon"
							:class="{ 'code-icon-hui': codePage == codeTotalPage }"
							@click="codePageChange('+')"
						></span>
					</div>
				</div>
				<!-- 下面折线图 -->
				<div class="right-chart" v-if="codeSelect.length">
					<el-form :model="queryParam" ref="warnform" :inline="true" class="flex flex_ju_sb warnform-inline rb-form">
						<div class="form-inputs">
							<el-form-item label="">
								<el-select placeholder="请选择" v-model="queryParam.listparam">
									<el-option
										v-for="(item, index) in itemsSelect"
										:key="index"
										:label="item.name"
										:value="item.code"
									></el-option>
								</el-select>
							</el-form-item>

							<el-form-item label="" class="form-picker">
								<div class="picker-divs picker-divs-more">
									<el-date-picker
										v-model="queryParam.startTime"
										size="small"
										type="datetime"
										placeholder="选择日期"
										popper-class="pick-poper"
										class="picker-div"
										format="yyyy-MM-dd HH:mm:ss"
										value-format="yyyy-MM-dd HH:mm:ss"
										prefix-icon=" "
										clear-icon="el-icon-date"
										:clearable="false"
										:picker-options="pickerOptions0"
										:editable="false"
									>
									</el-date-picker>
									<i class="pick-icon el-icon-date"></i>
									<i class="pick-icon-yuan el-icon-time"></i>
								</div>

								<span class="pick-word">至</span>
								<div class="picker-divs picker-divs-more">
									<el-date-picker
										v-model="queryParam.endTime"
										size="small"
										type="datetime"
										placeholder="选择日期"
										popper-class="pick-poper"
										class="picker-div"
										format="yyyy-MM-dd HH:mm:ss"
										value-format="yyyy-MM-dd HH:mm:ss"
										prefix-icon=" "
										clear-icon="el-icon-date"
										:clearable="false"
										:picker-options="pickerOptions1"
										:editable="false"
									>
									</el-date-picker>
									<i class="pick-icon el-icon-date"></i>
									<i class="pick-icon-yuan el-icon-time"></i>
								</div>
							</el-form-item>
						</div>

						<el-form-item class="form-btns">
							<el-button type="primary" @click="searchClick">查询</el-button>
						</el-form-item>
					</el-form>
					<!-- 图表 -->
					<div class="chart-lines" ref="chartLine" v-show="isLine"></div>
					<div class="table-empty chart-lines flex flex_col flex_a_c flex_ju_c" v-show="!isLine">
						<img class="table-noimg" src="@/assets/image/home/img_none.png" alt="" />
						<div class="table-emptyword">暂无气象数据</div>
					</div>
				</div>
				<div class="table-empty bottom-empty table-empty-big flex flex_col flex_a_c flex_ju_c right-empty" v-else>
					<img class="table-noimg" src="@/assets/image/sf/empty.png" alt="" />
					<div class="table-emptyword">该网点暂无传感设备!</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
/**
 * @description 生产监测
 */
import titleModel from '@/components/title-model.vue'
import tableMinin from '@/mixins/TableMinin'
import ProductionJs from './lib/production' // 页面专属js
import { todayTime, GetPreMonthDay, GetNextMonthDay, getFormatDate } from '../../times/moment'
import ProductionVideos from './components/productionVideos.vue'
// import videos from '@/components/video.vue'
// import HwCellPlayer from './components/HwCellPlayer.vue'
import ProductionLeft from './components/productionLeft.vue'
import ProductionRight from './components/productionRight.vue'
export default {
	components: { titleModel, ProductionLeft, ProductionRight, ProductionVideos },
	mixins: [tableMinin, ProductionJs],
	data() {
		return {
			tabIndex: 0, // tab选中值
			isMakeTime: false,
			// 表单数据
			// 左上角生产区域选择
			orgAllSelect: [], // 生产区域下拉选
			allOrgId: '', /// 分公司下面选中的orgid
			orgForm: {
				orgId: '',
			},
			orgSelect: [], // 分公司的另一个下拉选数据
			codeSelect: [], // 传感器下拉选,用作采集项的下拉选获取
			// 传感器选择表单， 用作采集项的下拉选获取
			codeForm: {
				deviceId: '',
			},
			codeDeviceTypeId: '', // 传感器id，用作获取传感器详细数据
			codeInfos: {}, // 传感器详细数据
			codeInfoLisst: [],
			codeIsWarn: false, // 传感器是否是异常状态
			codeLeftList: [], // 左边的数据
			codeRightList: [], // 右边的数据
			codePage: 1, // 实时数据当前页面
			codeTotalPage: 1, // 实时数据总页码
			videoSelect: [], // 视频监控的下拉选
			isShowVideo: true, // 是否显示视频
			isVideoEmpty: false, // 视频链接是否是空
			// 视频监控的表单，用作处理视频播放数据
			videoForm: {
				id: '',
			},
			equipList: {}, // 设备操作列表----全部
			equipListSd: [], // 开关设备
			equipListSsd: [], // 行程设备
			// equipListSsd: [
			// 	{
			// 		deviceName: '卷被机',
			// 		deviceStatus: 'STOP',
			// 		ssdDeviceStatus: 10,
			// 		explainStatus: 'STOP',
			// 	},
			// ], // 行程设备
			itemsSelect: [], // 采集项下拉选
			isLine: true, // 是否显示折线图
			url: {
				lineChart: '/napi/index/sensorDataChart',
			},
			pickerOptions0: {
				disabledDate: (time) => {
					if (this.queryParam.endTime) {
						if (this.queryParam.endTime != '') {
							let num = new Date(this.queryParam.endTime).getTime()
							return time.getTime() > num
						} else {
						}
					} else {
						return false
					}
				},
			},
			pickerOptions1: {
				disabledDate: (time) => {
					let num = new Date().getTime()
					if (time.getTime() > num) {
						return true
					} else {
						let startNum = new Date(this.queryParam.startTime).getTime() - 43200000
						if (time.getTime() < startNum) {
							return true
						} else {
							return false
						}
					}
				},
			},
			equipTime: null, // 定时请求的设备操作
		}
	},
	computed: {
		// tab切换的样式
		bgsStyle() {
			let params = {
				left: 0,
			}
			if (this.tabIndex == 0) {
				params = {
					left: 0,
				}
			} else {
				params = {
					left: '50%',
				}
			}
			return params
		},
	},
	// filters: {
	// 	equipWord(values, ssdDeviceStatus) {
	// 		let words = ''
	// 		switch (values) {
	// 			case 'STOP':
	// 				words = '已停止'
	// 				break
	// 			case 'DOWN':
	// 				words = `已下降${ssdDeviceStatus}`
	// 				break
	// 			case 'UP':
	// 				words = `已上升${ssdDeviceStatus}`
	// 				break
	// 			case 'STOPLOADING':
	// 				words = '停止响应中'
	// 				break
	// 			case 'DOWNLOADING':
	// 				words = '下降响应中'
	// 				break
	// 			case 'UPLOADING':
	// 				words = '上升响应中'
	// 				break

	// 			default:
	// 				break
	// 		}
	// 		return words
	// 	},
	// },
	watch: {
		equipListSsd: {
			handler(newval) {},
			deep: true,
		},
	},
	created() {
		// 时间赋值
		// this.$set(this.queryParam, 'listparam', 'WD')
		this.$set(this.queryParam, 'startTime', `${todayTime()} 00:00:00`)
		this.$set(this.queryParam, 'endTime', `${todayTime()} 23:59:59`)

		// TODO
		// let userInfo = this.getItem('wlwUserInfo') || {}
		// let userInfos = JSON.parse(userInfo)
		// this.$set(this.orgForm, 'orgId', userInfos.orgId)
	},
	mounted() {
		if (this.isShowAllSelect) {
			// 获取上面的生产区域信息
			this.getAllOrgids()
		} else {
			this.getOrgids()
		}
		// // 请求右下角折线图数据
		// this.getLineData()
		// 获取环境监测下拉选数据
		// this.getEnverSelect()
		// // 获取视频监控下拉选数据
		// this.getVideoSelect()
		// // 获取设备操作列表
		// this.getEquipList()
	},
	beforeDestroy() {
		if (this.equipTime) {
			clearInterval(this.equipTime)
			this.equipTime = null
		}
	},
	destroyed() {
		if (this.equipTime) {
			clearInterval(this.equipTime)
			this.equipTime = null
		}
	},
}
</script>
<style lang="scss" scoped>
@mixin scrolls() {
	overflow-y: scroll;
	// 背景
	&::-webkit-scrollbar {
		width: 8px;
		height: 8px;
		background-color: transparent;
		border-radius: 4px;
	}
	// 背景
	&::-webkit-scrollbar-track {
		width: 8px;
		height: 8px;
		background-color: transparent;
		border-radius: 4px;
	}
	// 滚动条
	&::-webkit-scrollbar-thumb {
		width: 8px;
		height: 8px;
		border-radius: 4px;
		background-color: #d9d9d9;
	}
}
.procudtionm-page {
	height: 100%;
	min-height: 610px;
	.table-empty {
		.table-emptyword {
			color: #797979;
			margin-top: 0.4rem;
			font-size: 0.17rem;
		}
	}
	.top-tipdiv {
		height: 0.3rem;
	}
	.icon_warn {
		width: 0.25rem;
		margin-right: 0.06rem;
		margin-top: -0.04rem;
	}
	// 下拉选
	.page-selects {
		margin-bottom: 0.13rem;
		.icon-small {
			width: 0.56rem;
			height: 0.3rem;
		}
		.top-forms {
			display: inline-block;
			padding-left: 0;
			margin-left: 0.21rem;
		}
	}
	.content-wraps {
		flex: 1;
		overflow: hidden;
	}
	// 下面的内容
	.left-wrap {
		height: 100%;
		.lt-wrap {
			width: 8.64rem;
			height: 53.2%;
			background: #ffffff;
			border-radius: 10px;
			.lt-videos {
				width: 8.14rem;
				height: 80%;
				background-color: #343434;
				margin: 0 auto;
			}
			.play-error {
				width: 100%;
				height: 100%;
				.img_noplay {
					width: 0.76rem;
					height: 0.64rem;
					margin-bottom: 0.46rem;
				}
			}
		}
		.tb-wrap {
			width: 8.64rem;
			height: 45.4%;
			background: #ffffff;
			border-radius: 10px;
			margin-top: 1.7%;
			.tips-img {
				width: 0.25rem;
				height: 0.25rem;
				margin-left: 0.125rem;
				position: relative;
				top: -0.02rem;
			}
			// 列表切换tab
			.btn-switchs {
				text-align: center;
				width: 2.5rem;

				background: #ffffff;
				border: 1px solid #2daea9;
				border-radius: 0.15rem;
				position: relative;
				// margin: 0 0 0.25rem 0.5rem;
				.btn-switch-btn {
					width: 50%;
					display: inline-block;
					height: 0.45rem;
					line-height: 0.45rem;
					font-size: 0.17rem;
					color: #2daea9;
					position: relative;
					z-index: 5;
					cursor: pointer;
					transition: color 0.5s;
				}
				.btn-switch-active {
					color: #ffffff;
				}
				// 背景颜色
				.bgs {
					width: 50%;
					height: 100%;
					background: #2daea9;
					border-radius: 0.13rem;
					position: absolute;
					left: 0;
					top: 0;
					z-index: 4;
					transition: left 0.5s;
				}
			}
			.lb-mains {
				width: 8.3rem;
				text-align: left;
				margin: 0.14rem 0.06rem 0 auto;
				height: 73%;
				@include scrolls();
			}
			// 开关设备 ------ start
			.switch-wrap {
				position: relative;
				display: inline-block;
				width: 3.9rem;
				height: 1.6rem;
				background-color: #e7f1f3;

				border-radius: 10px;
				&:nth-child(2n) {
					margin-left: 0.23rem;
				}
				&:nth-child(n + 3) {
					margin-top: 0.08rem;
				}
				.switch-div {
					width: 100%;
					height: 100%;
					padding: 0 0.3rem 0 0.24rem;
				}
				.switch-img {
					width: 1rem;
					height: 1rem;
					margin-right: 0.23rem;
				}
				.switch-name {
					font-size: 0.2rem;
					color: #333333;
				}
				.switch-status {
					font-size: 0.2rem;
					color: #2daea9;
					margin-top: 0.23rem;
				}
				.set_icon {
					width: 0.86rem;
					height: 0.36rem;
				}
			}
			.switch-wrap-off {
				background-color: #fcecec;
				.switch-status {
					color: #e33434;
				}
			}
			.codewarn {
				position: absolute;
				width: 100%;
				height: 100%;
				top: 0;
				left: 0;
				background-color: rgba($color: #fff, $alpha: 0.5);
				z-index: 10;
			}
			// 开关设备 ------ end
			// 行程设备 ------ start
			.equip-div {
				width: 3.9rem;
				height: 3.33rem;
				background: #e7f1f3;
				border-radius: 10px;
				display: inline-block;
				padding-top: 0.19rem;
				position: relative;
				&:nth-child(2n) {
					margin-left: 0.25rem;
				}
				&:nth-child(n + 3) {
					margin-top: 0.25rem;
				}
			}
			.equip-img {
				width: 1rem;
				height: 1rem;
				margin-right: 0.21rem;
			}
			.equip-name {
				font-size: 0.2rem;
				color: #333333;
			}
			.equip-status {
				font-size: 0.2rem;
				color: #2daea9;
				margin-top: 0.2rem;
			}
			// 进度条
			.div-progress {
				width: 3.39rem;

				height: 0.8rem;
				margin: 0.09rem auto;
				text-align: center;
				background-color: #fff;
				background: #ffffff;
				border-radius: 10px;
				.progress-num {
					color: #2daea9;
				}
				.progress-bg {
					width: 173px;
					height: 5px;
					background: #addad5;
					border-radius: 2px;
					position: relative;
					margin: 0 0.06rem 0 0.17rem;
					.progress-had {
						position: absolute;
						top: 0;
						left: 0;
						height: 100%;
						// width: 60%;
						background: #2daea9;
						border-radius: 2px;
						z-index: 5;
					}
				}
			}
			// 操作
			.equip-sets {
				width: 3.39rem;
				margin: auto;
				.equip-setdiv {
					width: 83px;
					height: 71px;
					background: #ffffff;
					border-radius: 10px;
					cursor: pointer;
					.seticon {
						width: 0.4rem;
						height: 0.4rem;
						margin-bottom: 0.11rem;
					}
					.seticon-smallicon {
						margin-top: 0.08rem;
						height: 0.25rem;
						width: 0.23rem;
						margin-bottom: 0.18rem;
					}
				}
			}

			// 行程设备 ----- end
		}
		.table-empty {
			.table-noimg {
				height: 2rem;
				width: auto;
			}
		}
	}
	// 右边
	.right-wrap {
		width: 11.22rem;
		height: 100%;

		background: #ffffff;

		border-radius: 10px;
		.right-top {
			position: relative;
			padding-top: 0.42rem;
			.relative-div {
				position: relative;
				width: 6.56rem;
				left: 50%;
				transform: translateX(-50%);
			}
			.relative-div-noleft {
				left: 0.6rem;
				transform: translateX(0);
			}
			.img_bg {
				width: 6.56rem;
				height: 2.75rem;
				margin-top: 0.21rem;
			}

			.icon_warn {
				width: 0.25rem;
				margin-right: 0.06rem;
				margin-top: -0.04rem;
			}
			.rt-absolute {
				position: absolute;
				width: 100%;
				height: 103%;
				top: 0;
				left: 0;
				padding: 0 0.25rem 0 0.38rem;
				z-index: 8;
			}
			.right-noleft {
				padding-right: 1.25rem;
			}
			.code-pages {
				position: absolute;
				z-index: 10;
				bottom: 0;
				left: 50%;
				transform: translateX(-50%);
				font-size: 0.17rem;
				.code-icon {
					color: #afafaf;
				}
				.code-icon-hui {
					color: #d8d8d8;
				}
			}
		}
		.right-chart {
			margin-top: 0.19rem;
			flex: 1;
			.rb-form {
				padding: 0 0.31rem;
				.form-btns {
					margin-right: 0;
				}
			}
			.chart-lines {
				width: 11.09rem;
				// height: 4.41rem;
				height: 85%;
				margin: 0.15rem auto 0;
			}
			.el-form-item {
				&:first-child {
					margin-right: 0.44rem;
					.el-select {
						width: 1.79rem;
					}
				}
			}
			.form-picker {
				.picker-div {
					width: 3rem;
				}
			}
		}
		.right-empty {
			flex: 1;
			.table-noimg {
				width: 4.1rem;
				height: 2.27rem;
			}
			.table-emptyword {
				margin-top: 0.65rem;
				font-size: 0.17rem;
			}
		}
	}
}
</style>
